import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../../icons";
import cn from "../../utils/cn";
import Typography from "../Typography";
export const Placeholder = ({ icon, text, className = "", children }) => {
    return (_jsxs("div", { className: cn("flex flex-col items-center justify-center space-y-2", className), children: [icon && _jsx(Icon, { name: icon, size: "md" }), _jsx(Typography, { className: "text-center", variant: "body", children: text }), children] }));
};
export default Placeholder;
